import _ from 'lodash';
import passable, { test, enforce } from 'passable';
import { mixpanel, bigQuery, stats } from '@fiverr-private/obs';
import { EMAIL_DOMAIN_PROVIDERS, EVENTS } from '../constants';

/**
 * returns the domain given an email address.
 * @param {String} email The full email address.
 * @return {String} The email domain
 */
export const extractEmailProvider = (email = '') => {
    if (!email) {
        return undefined;
    }

    const splitEmail = email.split('@');
    if (splitEmail.length !== 2) {
        return undefined;
    }

    return splitEmail[1];
};

/**
 * returns the email provider's url.
 * @param {String} provider The email provider key.
 * @return {String} the full url to the email provider
 */
export const extractUrlProvider = (provider) => {
    const domain = EMAIL_DOMAIN_PROVIDERS[provider];

    if (!domain) {
        return undefined;
    }

    return `http://${domain}`;
};

/**
 * returns the short domain name.
 * @param {String} emailProvider the email provider name.
 * @return {String} The shortened domain name
 */
export const shortenedEmailProvider = (emailProvider) => {
    if (!emailProvider) {
        return undefined;
    }

    return _.capitalize(emailProvider.split('.')[0]);
};

/**
 * Extracts email provider href and short name
 * @param {String} email
 * @return {Object} { providerHref, providerShortName }
 */
export const extractLinkProviderProps = (email) => {
    if (!email) {
        return;
    }
    const emailProvider = extractEmailProvider(email);
    const providerUrl = extractUrlProvider(emailProvider);
    const providerShortName = shortenedEmailProvider(emailProvider);

    return { providerUrl, providerShortName };
};

/**
 * validates an email address
 * @param {String} email The full email address.
 * @return {Array} an array containing the error message
 */
export const validateEmail = (email) => passable('newEmail', () => {
    const errorKeyPrefix = 'layout.global_messages.user_activation.errors.email';

    test('email', `${errorKeyPrefix}.empty`, () => {
        enforce(email).isNotEmpty();
    });

    test('email', `${errorKeyPrefix}.invalid`, () => {
        enforce(email).matches(/^([a-zA-Z0-9.\-+_])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/);
    });
}).errors.email || [];

/**
 * Tracks a given event to all related tracking platforms.
 * @param {String} type The event that occurred.
 */
export const trackEvent = (type) => {
    const event = EVENTS[type];

    event.bigQuery && bigQuery.send({ type: event.bigQuery });
    event.mixpanel && mixpanel.track(event.mixpanel);
    event.grafana && stats.count('activation_banner', event.grafana);
};
